@if ((loading$ | async) && ((loaded$ | async) === false || (loggedIn$ | async))) {
  <div aria-busy="true" class="portal-initialization-loader">
    <span class="visually-hidden" role="status">{{ 'core-portal.core.general.loading' | translate }}</span>
    <app-layout [forceGhost]="true"></app-layout>
  </div>
} @else {
  <router-outlet></router-outlet>
}
